export const adaptMultipleToIds = (selected) => {
  if (!selected || !selected.length) return [];
  return selected.map((obj) => obj.label);
};
